import {
  Field,
  FieldArray,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import React, { useEffect, useRef, useState } from "react";
import ShadowCard from "../../components/common/ShadowCard";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import FormDatePicker from "../../components/formFields/FormDateField";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import moment from "moment";
import { RootState } from "../../app/store";
import {
  getKarigarListByProcess,
  getKarigarStock,
} from "../karigar/services/karigar.services";
import { LoadingPanel } from "../../components/layout/Loading";
import { IKarigarListByProcess } from "../karigar/karigarModel";
import { findAllActiveItem } from "../item/services/item.services";
import {
  createMinaReceipt,
  findAllPendingMinaOrder,
  getMinaReceiptById,
  updateMinaReceipt,
} from "./services/minaReceipt.services";
import { findAllActiveProcess } from "../process/services/process.services";
import { clearMinaReceiptDetail } from "./minaReceiptSlice";
import { ErrorToast } from "../../components/toast/Toasts";
import { clearOrderDetail } from "../order/orderSlice";
import MinaReceiptOrderItemArray from "./MinaReceiptOrderItemArray";
import FormTextField from "../../components/formFields/FormTextField";
import MinaReceiptOrderSelectionDialog from "./MinaReceiptOrderSelectionDialog";
import { PRINT_ACCESS, PROCESS_ID } from "../../_contstants/common";
import { clearKarigarStock } from "../karigar/karigarSlice";
import {
  checkAcessRights,
  formatToIndianCurrencyWithoutSymbol,
  formatWeight,
} from "../../_helper/helper";
import { FaEye } from "react-icons/fa";

interface FormChangeWatcherProps {
  formRenderProps: FormRenderProps;
}
const KarigarChangeWatcher: React.FC<FormChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const karigar_id = formRenderProps.valueGetter("karigar_id");
  const KarigarList = useAppSelector(
    (state) => state.karigar?.KarigarListByProcess,
  );
  const charges = formRenderProps.valueGetter("charges");
  const gold_rate = formRenderProps.valueGetter("gold_rate");
  const mina_receipt_order = formRenderProps.valueGetter("mina_receipt_order");
  const dispatch = useAppDispatch();

  const fetchKarigarStock = async (karigar_id: number) => {
    await dispatch(getKarigarStock(karigar_id));
  };

  useEffect(() => {
    if (karigar_id) {
      dispatch(findAllPendingMinaOrder({ karigar_id: karigar_id }));
      fetchKarigarStock(karigar_id);
      if (karigar_id && KarigarList?.length > 0) {
        const selectedKarigar = KarigarList.find(
          (karigar) => karigar.karigar_id === karigar_id,
        );
        if (selectedKarigar) {
          const Rate = selectedKarigar?.rate;
          formRenderProps.onChange(`charges`, {
            value: Rate || 0,
          });
        }
      }
    }
  }, [karigar_id]);

  useEffect(() => {
    if (mina_receipt_order && mina_receipt_order.length > 0) {
      mina_receipt_order?.forEach((element: any, index: number) => {
        const total_charge = element.mina_Weight * (charges || 0);
        const mina_Weight = element.received_weight - element.issue_weight;
        // const amount = (ghat_weight || 0) * (gold_rate || 0);
        formRenderProps.onChange(`mina_receipt_order.${index}.total_charge`, {
          value: total_charge,
        });
        // formRenderProps.onChange(`mina_receipt_order.${index}.ghat_weight`, {
        //   value: ghat_weight,
        // });
        formRenderProps.onChange(`mina_receipt_order.${index}.mina_Weight`, {
          value: mina_Weight,
        });
        // formRenderProps.onChange(`mina_receipt_order.${index}.amount`, {
        //   value: amount,
        // });
      });
    }
  }, [
    mina_receipt_order?.map((item: any) => item?.issue_weight).join("-"),
    mina_receipt_order?.map((item: any) => item?.received_weight).join("-"),
    mina_receipt_order?.map((item: any) => item?.mina_Weight).join("-"),
    charges,
    gold_rate,
  ]);
  return null;
};

const CreateMinaReceipt: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const mina_receipt_guid = location?.state?.mina_receipt_guid;
  const loading = useAppSelector((state) => state.minareceipt?.loading);
  const karigarStock = useAppSelector((state) => state.karigar.KarigarStock);
  const isPrintAccess = checkAcessRights(
    "/" + location.pathname.split("/")[1],
    PRINT_ACCESS,
  );
  const KarigarListByProcess = useAppSelector(
    (state) => state.karigar?.KarigarListByProcess,
  );
  const MinaReceiptDetail = useAppSelector(
    (state: RootState) => state.minareceipt.MinaReceiptDetail,
  );
  const [formKey, setFormKey] = useState(1);

  useEffect(() => {
    dispatch(getKarigarListByProcess(PROCESS_ID.mina));
    dispatch(findAllActiveItem());
    dispatch(findAllActiveProcess());
    return () => {
      dispatch(clearMinaReceiptDetail());
      dispatch(clearOrderDetail());
      dispatch(clearKarigarStock());
    };
  }, []);

  useEffect(() => {
    if (mina_receipt_guid) {
      dispatch(getMinaReceiptById(mina_receipt_guid));
    }
  }, [mina_receipt_guid]);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [MinaReceiptDetail]);

  const handleSubmit = async (values: any) => {
    if (values.mina_receipt_order?.length === 0) {
      ErrorToast("At least One Order is Required !");
      return false;
    }
    const formData = {
      karigar_id: values.karigar_id ? +values.karigar_id : null,
      receipt_date: values.receipt_date
        ? moment(values.receipt_date).format("YYYY-MM-DD")
        : "",
      charges: values?.charges ? values?.charges : 0,
      gold_rate: values?.gold_rate ? values?.gold_rate : 0,

      mina_receipt_order: values.mina_receipt_order
        ? values.mina_receipt_order.map((minareceiptOrder: any) => {
            return {
              id: minareceiptOrder.id ? minareceiptOrder.id : 0,
              order_id: minareceiptOrder.order_id
                ? +minareceiptOrder.order_id
                : null,
              order_no: minareceiptOrder.order_no
                ? +minareceiptOrder.order_no
                : null,
              item_id: minareceiptOrder.item_id
                ? +minareceiptOrder.item_id
                : null,
              item_description: minareceiptOrder.item_description
                ? minareceiptOrder.item_description
                : "",
              issue_weight: minareceiptOrder.issue_weight
                ? minareceiptOrder.issue_weight
                : 0,
              received_weight: minareceiptOrder.received_weight
                ? minareceiptOrder.received_weight
                : 0,
              total_charge: minareceiptOrder.total_charge
                ? minareceiptOrder.total_charge
                : 0,
              ghat_weight: minareceiptOrder.ghat_weight
                ? minareceiptOrder.ghat_weight
                : 0,
              mina_Weight: minareceiptOrder.mina_Weight
                ? minareceiptOrder.mina_Weight
                : 0,
              amount: minareceiptOrder.amount ? minareceiptOrder.amount : 0,
              isfinishorder: minareceiptOrder.isfinishorder
                ? minareceiptOrder.isfinishorder
                : false,
              IsVerified: minareceiptOrder.IsVerified
                ? minareceiptOrder.IsVerified
                : false,
            };
          })
        : [],
    };
    if (mina_receipt_guid) {
      const editPayload = {
        mina_receipt_guid: mina_receipt_guid,
        mina_receipt_no: values.mina_receipt_no,
        ...formData,
      };
      try {
        const response = await dispatch(updateMinaReceipt(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          navigate("/minareceipt");
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    } else {
      try {
        const response = await dispatch(createMinaReceipt(formData));
        if (response?.meta?.requestStatus === "fulfilled") {
          navigate("/minareceipt");
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    }
  };
  const handleFormClose = () => {
    navigate("/minareceipt");
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <Form
        onSubmit={handleSubmit}
        key={formKey}
        initialValues={MinaReceiptDetail}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <MinaReceiptOrderSelectionDialog
              formRenderProps={formRenderProps}
            />
            <KarigarChangeWatcher formRenderProps={formRenderProps} />
            <ShadowCard style={{ padding: 12 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                ]}
              >
                <GridLayoutItem colSpan={3}>
                  <Typography.h4>
                    {mina_receipt_guid
                      ? "Update Mina Receipt"
                      : "Create Mina Receipt"}
                  </Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem colSpan={3}>
                  {mina_receipt_guid ? (
                    <Typography.h5>
                      Mina Receipt No :{" "}
                      <span style={{ color: "green" }}>
                        {MinaReceiptDetail.mina_receipt_no}
                      </span>
                    </Typography.h5>
                  ) : (
                    ""
                  )}
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="karigar_id"
                    label="Karigar Name"
                    placeholder="Select Karigar"
                    isAddNew={true}
                    addNewLink="karigar/create"
                    dispatcherFunction={getKarigarListByProcess}
                    dispatcherFunctionPayload={PROCESS_ID.mina}
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    options={KarigarListByProcess?.map(
                      (karigar: IKarigarListByProcess) => {
                        return {
                          value: karigar?.karigar_id,
                          label: `${karigar?.karigar_nick_name || karigar?.karigar_name}`,
                        };
                      },
                    )}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="receipt_date"
                    label="Receipt Date"
                    placeholder="day/month/year"
                    format={"dd/MM/yyyy"}
                    component={FormDatePicker}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <div className="stock-container">
                    <div className="stock-item">
                      <div className="stock-header">
                        <div
                          className={`indicator-dot amount-dot-${karigarStock.Amount_credit_debit}`}
                        ></div>
                        <Typography.h6 className="stock-label">
                          Amount Balance
                        </Typography.h6>
                      </div>
                      <Typography.h6
                        className={`stock-value amount-value-${karigarStock.Amount_credit_debit}`}
                      >
                        {formatToIndianCurrencyWithoutSymbol(
                          karigarStock.amount || 0,
                        )}{" "}
                        <span
                          style={{
                            fontWeight: "normal",
                            textTransform: "capitalize",
                            fontSize: 16,
                          }}
                        >
                          {karigarStock.Amount_credit_debit}
                        </span>
                      </Typography.h6>
                    </div>

                    <div className="stock-item">
                      <div className="stock-header">
                        <div
                          className={`indicator-dot phine-dot-${karigarStock.phine_credit_debit}`}
                        ></div>
                        <Typography.h6 className="stock-label">
                          Phine (gm) Stock
                        </Typography.h6>
                      </div>
                      <Typography.h6
                        className={`stock-value phine-value-${karigarStock.phine_credit_debit}`}
                      >
                        {formatWeight(karigarStock.phine)}{" "}
                        <span
                          style={{
                            fontWeight: "normal",
                            textTransform: "capitalize",
                            fontSize: 16,
                          }}
                        >
                          {karigarStock.phine_credit_debit}
                        </span>
                      </Typography.h6>
                    </div>
                  </div>
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="charges"
                    label="Charges"
                    placeholder="i.e. 2"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                {/* <GridLayoutItem>
                  <Field
                    name="gold_rate"
                    label="Gold Rate (GM)"
                    placeholder="i.e. 8500"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem> */}
              </GridLayout>
            </ShadowCard>
            <ShadowCard style={{ marginTop: 10 }}>
              <GridLayout cols={[{ width: "100%" }]}>
                <GridLayoutItem>
                  <Typography.h4>Mina Receipt Orders</Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem>
                  <FieldArray
                    formRenderProps={formRenderProps}
                    component={MinaReceiptOrderItemArray}
                    name="mina_receipt_order"
                    mina_receipt_guid={mina_receipt_guid}
                  />
                </GridLayoutItem>
                <GridLayoutItem
                  style={{
                    textAlign: "end",
                    marginTop: "20px",
                    width: "100%",
                  }}
                >
                  {isPrintAccess && mina_receipt_guid && (
                    <Button
                      type="button"
                      style={{ marginRight: 4 }}
                      fillMode={"solid"}
                      themeColor={"primary"}
                      onClick={() =>
                        window.open(
                          `/minareceipt/${mina_receipt_guid}`,
                          "_blank",
                        )
                      }
                    >
                      <FaEye style={{ fontSize: "18" }} /> View Report
                    </Button>
                  )}
                  <ButtonWithLoading
                    label={!mina_receipt_guid ? "Create" : "Update"}
                    type="submit"
                    disabled={!formRenderProps.allowSubmit || loading}
                    loading={loading}
                  />
                  <Button
                    type="button"
                    fillMode={"outline"}
                    themeColor={"primary"}
                    style={{ marginLeft: 4 }}
                    onClick={handleFormClose}
                  >
                    Cancel
                  </Button>
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
          </FormElement>
        )}
      />
    </>
  );
};

export default CreateMinaReceipt;
